"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSpacesFromResource = exports.crepoResourceFromPartial = exports.assetToCrepoResourceReference = exports.crepoResourceReference = exports.requireIdForType = exports.hasType = exports.extractIdFromContentId = exports.masterType = exports.crepoResourceUrl = exports.masterId = exports.crepoId = exports.crepoType = exports.resourceToStencil = exports.tagsToStencil = exports.personProfilesToStencil = exports.locationsToStencil = exports.contentCollectionToStencil = exports.transformToAssetLocalizationIdentifier = void 0;
const rbcom_content_schema_1 = require("@cds/rbcom-content-schema");
const crepo_content_api_node_sdk_cjs_1 = require("@crepo/crepo-content-api-node-sdk-cjs");
const models_1 = require("../models");
const language_code_util_1 = require("./language-code.util");
const object_util_1 = require("./object.util");
const transformToAssetLocalizationIdentifier = (resource) => {
    const { guid, locale } = (0, crepo_content_api_node_sdk_cjs_1.parseResourceId)(resource.id);
    if (!locale || !(0, models_1.isFullLanguageCode)(locale)) {
        throw new Error(`The locale for resource '${resource.id}' could not be parsed`);
    }
    if (!(0, models_1.isUuid)(guid)) {
        throw new Error(`The uuid for resource '${resource.id}' could not be parsed`);
    }
    return {
        id: guid,
        localization: (0, language_code_util_1.tryRemoveInternationalization)(locale),
    };
};
exports.transformToAssetLocalizationIdentifier = transformToAssetLocalizationIdentifier;
const contentCollectionToStencil = (editorial, subType) => {
    if (editorial) {
        return 'editorial-list';
    }
    if (subType === 'content-hub') {
        return 'content-hub';
    }
    if (subType === 'discipline' || subType === 'custom' || subType === 'playlist') {
        return 'content-collection';
    }
    return undefined;
};
exports.contentCollectionToStencil = contentCollectionToStencil;
const locationsToStencil = (precision) => {
    switch (precision) {
        case 'address':
            return 'geolocation';
        case 'country':
            return 'country';
        case 'orb':
            return 'worldwide-geolocation';
        case 'virtual':
            return 'virtual-geolocation';
        default:
            return undefined;
    }
};
exports.locationsToStencil = locationsToStencil;
const personProfilesToStencil = (subType) => {
    switch (subType) {
        case 'artist':
            return 'artist';
        case 'athlete':
            return 'athlete';
        default:
            return undefined;
    }
};
exports.personProfilesToStencil = personProfilesToStencil;
const tagsToStencil = (subType) => {
    switch (subType) {
        case 'abstract':
        case 'discipline-pseudogroup':
            return 'collection';
        case 'custom':
            return 'content-category';
        case 'playground':
        case 'playground-project':
            return 'playground';
        case 'discipline':
            return subType;
        default:
            return undefined;
    }
};
exports.tagsToStencil = tagsToStencil;
// eslint-disable-next-line max-lines-per-function
const resourceToStencil = (resource
// eslint-disable-next-line sonarjs/cognitive-complexity
) => {
    if ((0, rbcom_content_schema_1.isAppleImmersiveVideo)(resource)) {
        return 'apple-immersive-video';
    }
    if ((0, rbcom_content_schema_1.isAudioClip)(resource)) {
        return 'audio-clip';
    }
    if ((0, rbcom_content_schema_1.isAudioEpisode)(resource)) {
        return 'podcast-episode';
    }
    if ((0, rbcom_content_schema_1.isAudioSeason)(resource)) {
        return 'podcast-season';
    }
    if ((0, rbcom_content_schema_1.isAudioSeries)(resource)) {
        return 'podcast-show';
    }
    if ((0, rbcom_content_schema_1.isAuthorProfile)(resource)) {
        return 'author';
    }
    if ((0, rbcom_content_schema_1.isContentCollection)(resource)) {
        return (0, exports.contentCollectionToStencil)(resource.attributes.editorial, resource.attributes.subType);
    }
    if ((0, rbcom_content_schema_1.isEnergyDrink)(resource)) {
        return 'energy-drink';
    }
    if ((0, rbcom_content_schema_1.isEpisodeVideo)(resource)) {
        return 'episode-video';
    }
    if ((0, rbcom_content_schema_1.isEventDetail)(resource)) {
        return 'event-details';
    }
    if ((0, rbcom_content_schema_1.isEventProfile)(resource)) {
        return 'event-profile';
    }
    if ((0, rbcom_content_schema_1.isEventSeason)(resource)) {
        return 'event-season';
    }
    if ((0, rbcom_content_schema_1.isEventSeries)(resource)) {
        return 'event-series';
    }
    if ((0, rbcom_content_schema_1.isExternalContent)(resource)) {
        return 'external-content-resource';
    }
    if ((0, rbcom_content_schema_1.isExternalPerson)(resource)) {
        return 'external-person';
    }
    if ((0, rbcom_content_schema_1.isExternalTeam)(resource)) {
        return 'external-team';
    }
    if ((0, rbcom_content_schema_1.isFilm)(resource)) {
        return 'film';
    }
    if ((0, rbcom_content_schema_1.isImage)(resource)) {
        return 'image';
    }
    if ((0, rbcom_content_schema_1.isImageGallery)(resource)) {
        return 'image-gallery';
    }
    if ((0, rbcom_content_schema_1.isImmersive3DModel)(resource)) {
        return 'immersive-3d-model';
    }
    if ((0, rbcom_content_schema_1.isJudge)(resource)) {
        return 'judge';
    }
    if ((0, rbcom_content_schema_1.isLiveVideo)(resource)) {
        return 'live-video';
    }
    if ((0, rbcom_content_schema_1.isLocation)(resource)) {
        return (0, exports.locationsToStencil)(resource.attributes.location.precision);
    }
    if ((0, rbcom_content_schema_1.isMisc)(resource)) {
        return 'misc';
    }
    if ((0, rbcom_content_schema_1.isOccasion)(resource)) {
        return 'occasion';
    }
    if ((0, rbcom_content_schema_1.isOccasionCampaign)(resource)) {
        return 'occasion-campaign';
    }
    if ((0, rbcom_content_schema_1.isOnsitePromotion)(resource)) {
        return 'onsite-promotion';
    }
    if ((0, rbcom_content_schema_1.isPartnerProfile)(resource)) {
        return 'partner-profile';
    }
    if ((0, rbcom_content_schema_1.isPersonProfile)(resource)) {
        return (0, exports.personProfilesToStencil)(resource.attributes.subType);
    }
    if ((0, rbcom_content_schema_1.isPhotographer)(resource)) {
        return 'photographer';
    }
    if ((0, rbcom_content_schema_1.isPreviewClip)(resource)) {
        return 'preview-clip';
    }
    if ((0, rbcom_content_schema_1.isProjectProfile)(resource)) {
        return 'project-profile';
    }
    if ((0, rbcom_content_schema_1.isRallyDriver)(resource)) {
        return 'rally-driver';
    }
    if ((0, rbcom_content_schema_1.isRallyTeam)(resource)) {
        return 'rally-team';
    }
    if ((0, rbcom_content_schema_1.isRecapVideo)(resource)) {
        return 'recap-video';
    }
    if ((0, rbcom_content_schema_1.isResultsAndStandings)(resource)) {
        return 'results-and-standings';
    }
    if ((0, rbcom_content_schema_1.isSeason)(resource)) {
        return 'season';
    }
    if ((0, rbcom_content_schema_1.isShow)(resource)) {
        return 'show';
    }
    if ((0, rbcom_content_schema_1.isStory)(resource)) {
        return 'story';
    }
    if ((0, rbcom_content_schema_1.isTag)(resource)) {
        return (0, exports.tagsToStencil)(resource.attributes.subType);
    }
    if ((0, rbcom_content_schema_1.isTeamProfile)(resource)) {
        return 'team';
    }
    if ((0, rbcom_content_schema_1.isTrailerVideo)(resource)) {
        return 'trailer-video';
    }
    if ((0, rbcom_content_schema_1.isTvCommercial)(resource)) {
        return 'tv-commercial';
    }
    if ((0, rbcom_content_schema_1.isTvPartnerChannel)(resource)) {
        return 'tv-partner-channel';
    }
    if ((0, rbcom_content_schema_1.isVideo)(resource)) {
        return 'video';
    }
    if ((0, rbcom_content_schema_1.isVideo3D)(resource)) {
        return 'video-3d';
    }
    if ((0, rbcom_content_schema_1.isVideo360)(resource)) {
        return 'video-vr-360';
    }
    if ((0, rbcom_content_schema_1.isVideoChannel)(resource)) {
        return 'video-channel';
    }
    return undefined;
};
exports.resourceToStencil = resourceToStencil;
const crepoType = (localization) => {
    const type = models_1.stencilToContentTypeMapping[localization.stencil];
    if (type) {
        return `rrn:content:${type}`;
    }
    else {
        throw new Error(`There is no mapping for type "${type}"`);
    }
};
exports.crepoType = crepoType;
const crepoId = (localization) => `${(0, exports.crepoType)(localization)}:${localization.id}:${(0, language_code_util_1.tryAddInternationalization)(localization.localization)}`;
exports.crepoId = crepoId;
const masterId = (localization) => `${(0, exports.crepoType)(localization)}:${localization.id}`;
exports.masterId = masterId;
const crepoResourceUrl = (localization) => `/v4/types/${(0, exports.crepoType)(localization)}/resources/${(0, exports.crepoId)(localization)}`;
exports.crepoResourceUrl = crepoResourceUrl;
const masterType = (stencil) => {
    return `rrn:master:${models_1.stencilToContentTypeMapping[stencil]}`;
};
exports.masterType = masterType;
const extractIdFromContentId = (contentId) => {
    return (0, crepo_content_api_node_sdk_cjs_1.parseResourceId)(contentId).guid;
};
exports.extractIdFromContentId = extractIdFromContentId;
const hasType = (value) => typeof value === 'object' && !Array.isArray(value) && value !== undefined && value !== null && 'type' in value;
exports.hasType = hasType;
const requireIdForType = (type, id) => {
    if (!id.startsWith(type)) {
        throw Error('invalid id');
    }
    return id;
};
exports.requireIdForType = requireIdForType;
const crepoResourceReference = (id, stencil) => {
    const stencilName = (0, models_1.stencilNameFromString)(stencil);
    const type = models_1.stencilToContentTypeMapping[stencilName];
    const reference = {
        id: `rrn:content:${type}:${id}`,
        type: `rrn:master:${type}`,
    };
    if ((0, rbcom_content_schema_1.isContentReferenceTypeGroup)(reference)) {
        return reference;
    }
    else {
        throw new Error(`There is no mapping for stencil "${stencil}"`);
    }
};
exports.crepoResourceReference = crepoResourceReference;
const assetToCrepoResourceReference = (asset) => {
    if (asset) {
        const stencilName = asset.stencil;
        const id = asset.id;
        return stencilName ? (0, exports.crepoResourceReference)(id, stencilName) : undefined;
    }
    return undefined;
};
exports.assetToCrepoResourceReference = assetToCrepoResourceReference;
const crepoResourceFromPartial = (resource) => {
    if (!(0, object_util_1.isPartialComplete)(resource, 'id', 'type')) {
        throw new Error('The properties "id" and/or "type" are not defined');
    }
    return resource;
};
exports.crepoResourceFromPartial = crepoResourceFromPartial;
const extractSpacesFromResource = (resource) => {
    const spaces = resource.meta?.spaces ?? [];
    if (!spaces.every(models_1.isSpace)) {
        throw new Error(`Not all spaces from the resource with id '${resource.id}' are valid. Spaces: ${spaces.join(',')}`);
    }
    return spaces;
};
exports.extractSpacesFromResource = extractSpacesFromResource;
//# sourceMappingURL=data:application/json;base64,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